var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"color-sample s1-west"},[_c('section',[_c('p',{staticClass:"default-text"},[_vm._v("\n      源頼朝\n    ")])])])}]

export { render, staticRenderFns }